const baseURLApi = process.env.VUE_APP_API_BASE_URL || "https://api.cst-occ.de";

export default {
  baseURLApi,
  isBackend: process.env.VUE_APP_BACKEND,
  api: {
    url: `${baseURLApi}/api`,
  },
  locale: {
    currency: "EUR",
    language: "de",
    numberStyle: "de-DE",
    digit: 4,
  },
};
